import fetchJSON from './fetchJSON';
import URL from 'url';

interface FetchPaginatedJSONOptions {
    itemsPerPage?: number;
    maxItems?: number;
    firstPage?: number;
}

export default async function* fetchPaginatedJSON<T>(url: string, {
    itemsPerPage = 1000,
    maxItems = 1000000,
    firstPage = 1
}: FetchPaginatedJSONOptions = {}): AsyncIterable<T> {

    const lastPage = Math.ceil(maxItems / itemsPerPage) + firstPage - 1;

    for (let page = firstPage; page <= lastPage; page++) {

        const data = await fetchJSON.memoized(appendQueryParams(url, {
            page,
            count: itemsPerPage,
        }));

        for (const datum of data) {
            yield datum;
        }

        if (data.length < itemsPerPage) return;
    }
}

function appendQueryParams(input: string, query: Record<string, any>) {
    const parsed = URL.parse(input, true);
    return URL.format({...parsed, query: {...parsed.query, ...query}});
}
